import React, { useState } from 'react';
import 'moment/locale/pt-br';
import moment from 'moment';
import { IncomeTypes } from 'store/modules/my_account_store/types';
import ModalBoleto from '../modal_boleto';

interface TableIncomesProps {
  data: Array<IncomeTypes>;
  title: string;
}

const TableIncomes = (props: TableIncomesProps) => {
  moment.locale('pt-br');
  const { data, title } = props;
  const [showModal, setShowModal] = useState<boolean>(false);
  const [incomeId, setIncomeId] = useState<number>(0);
  const [parcela, setParcela] = useState<number>(0);

  const handleClick = (income: number, parcela: number) => {
    setShowModal(true);
    setIncomeId(income);
    setParcela(parcela);
  };

  return (
    <div className="row">
      <div className="col-md-12 mb-2">
        <h5>{title}</h5>
        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col">Parcela</th>
                <th scope="col">Valor*</th>
                <th scope="col">Vencimento</th>
                <th scope="col">Situação</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((income) => (
                <>
                  <tr>
                    <th scope="row">{income?.parcela}</th>
                    <td>
                      {Number(income?.valor).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </td>
                    <td>{`${moment.parseZone(income?.data_vencimento).format('L')}`}</td>
                    <td>
                      {!income?.data_pagamento &&
                        income?.situacao_receita_id === 3 &&
                        'Boleto cancelado'}
                      {!income?.data_pagamento &&
                        income?.situacao_receita_id !== 3 &&
                        'Boleto em aberto'}
                      {income?.data_pagamento &&
                        `pago em ${moment.parseZone(income?.data_pagamento).format('L')}`}
                    </td>
                    <td>
                      {income?.situacao_receita_id === 1 &&
                        moment.parseZone(income?.data_vencimento).format('L') >=
                          moment(new Date()).format('DD/MM/YYYY') && (
                          <button
                            type="button"
                            className="btn btn-success"
                            onClick={() => handleClick(income?.id, income?.parcela)}
                          >
                            Gerar boleto
                          </button>
                        )}
                      {moment.parseZone(income?.data_vencimento).format('L') <
                        moment(new Date()).format('DD/MM/YYYY') &&
                        income?.situacao_receita_id === 1 && (
                          <button
                            type="button"
                            className="btn btn-warning"
                            onClick={() => handleClick(income?.id, income?.parcela)}
                          >
                            Gerar 2ª via
                          </button>
                        )}
                      {income?.situacao_receita_id === 2 && <p>Paga</p>}
                    </td>
                  </tr>
                  <div />
                </>
              ))}
            </tbody>
          </table>
        </div>
        <ModalBoleto
          showModal={showModal}
          id_income={incomeId}
          setShowModal={setShowModal}
          parcela={parcela}
        />
      </div>
    </div>
  );
};

export default TableIncomes;
